import SkeletonLoader from "../skeleton_loader.js";
const newText = gettext("NEW");

export const CountryPackageBundleBs3 = (props) => {
    let packageBundle = props.packageBundle;
    let limitKey = props.hasLimit;
    const isWeatherBundle = packageBundle.key === 'ch.xample.services.weather';
    const isFlightPLan = packageBundle.key === 'ch.xample.services.flightplan';
    const limitText = props.hasLimit ? interpolate(gettext("%s filings/30 days"), [limitKey]) : null;
    //ch.xample.services.weather
    let isNew = isWeatherBundle ? 'wrapper-ribbon' : '';
    let isSet = packageBundle.hasOwnProperty("is_set") && packageBundle.is_set ? "set-item": "pkg-item";
    return (
        <React.Fragment>
            <div pkgkey={packageBundle.key} className={`panel-footer pkg-bundle ${isSet}`}>
                {props.isLoading && <SkeletonLoader width={'90%'} height={'20px'} />}
                {!props.isLoading && <React.Fragment>
                    {packageBundle.name + " "}
                    {isFlightPLan && props.hasLimit && limitText}
                    {/*{isWeatherBundle && <span className="label label-success">{newText}</span>}*/}
                </React.Fragment>}
                {/*{isWeatherBundle ? <div className="ribbon-wrapper-yellow-single">*/}
                {/*    <div className="ribbon-yellow-single">{newText}</div>*/}
                {/*</div> : null}*/}
            </div>
        </React.Fragment>

    )
}

export const CountryPackageBundleBs5 = (props) => {
    let packageBundle = props.packageBundle;
    let isWeatherBundle = packageBundle.key === 'ch.xample.services.weather';
    //ch.xample.services.weather
    let isNew = isWeatherBundle ? 'wrapper-ribbon' : '';
    let isSet = packageBundle.hasOwnProperty("is_set") && packageBundle.is_set ? "set-item": "pkg-item";
    return (
        <React.Fragment>
            <div pkgkey={packageBundle.key} className={`card-footer pkg-bundle ${isSet}`}>
                {props.isLoading && <SkeletonLoader width={'90%'} height={'20px'} />}
                {!props.isLoading && <React.Fragment>
                    {packageBundle.name + " "}
                    {/*{isWeatherBundle && <span className="badge has-bg-success">{newText}</span>}*/}
                </React.Fragment>}
                {/*{isWeatherBundle ? <div className="ribbon-wrapper-yellow-single">*/}
                {/*    <div className="ribbon-yellow-single">{newText}</div>*/}
                {/*</div> : null}*/}
            </div>
        </React.Fragment>

    )
}
